export const IMMERSION_LIST = [
  {
    title: '沉浸式的活动体验',
    desc: ['打造个性虚拟角色，一键登入元宇宙空间', '突破传统活动体验，沉浸式漫游虚拟世界'],
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll52vfmf_031766.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgaunoeo_118348.mp4',
    using: ['pc', 'h5'],
    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxc4hh_084340.jpg',
  },
  {
    title: '多样化的交互方式',
    desc: ['屏幕共享、PPT 嵌入式播放、绿幕直播', '圆桌会议、视频聊天、实时翻译', '支持文字、语音、表情、动作等'],
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll52vfmk_031767.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd4vwnr_230806.mp4',
    using: ['pc', 'h5'],
    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd54x1j_651206.png',
  },
  {
    title: '创新性仪式打造',
    desc: ['自定义烟花、酷炫无人机', '企业文化衫、员工颁奖', '弹幕刷屏、集体舞蹈、合影留念'],
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll52vfmg_031766.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgaunoem_118348.mp4',
    using: ['pc', 'h5'],

    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxc4hj_084341.jpg',
  },
  {
    title: '各类型的互动游戏',
    desc: [
      ['大屏互动', '·', '抽奖寻宝', '·', '在线 PK'],
      ['3D 签到', '·', '许愿池', '·', '抢红包'],
      '多种互动游戏，提升参与度与趣味性',
    ],
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll52vfmi_031766.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgaunoel_118348.mp4',
    using: ['pc', 'h5'],
    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxc4hk_084341.jpg',
  },
  {
    title: '自定义空间场景',
    desc: ['支持空间图文、音视频等素材自由替换', '支持空间场景多功能区分', '支持打造自定义私域元宇宙'],
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll52vfmj_031767.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgaunoek_118348.mp4',
    using: ['pc', 'h5'],
    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxc4hl_084341.jpg',
  },
  {
    title: '随时随地便捷访问',
    desc: '无需下载、安装，输入门票即可一键参与，轻松打破传统活动时空局限',
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll52vfmh_031766.png',
    video: null,
    using: ['h5'],
  },
];
